import { Row, Col, Typography } from 'antd';
import PropTypes from 'prop-types';
import QRCode from 'react-qr-code';
import { LRSummaryItemBlock } from './LRViewSummaryItem';
import { LRStyle } from './LRStyleSet';

const { Text } = Typography;

const BORDER_STYLE = '1px solid #d9d9d9';

const tableCellStyle = {
	padding: '4px 8px',
	textAlign: 'left',
	fontWeight: 'bold',
	wordBreak: 'break-word',
	border: BORDER_STYLE,
	fontSize: '11px',
};

const generateId = (() => {
	let id = 0;
	return () => {
		id += 1;
		return `id-${id}`;
	};
})();

export function LRViewSummary({ details }) {
	function parseReferenceNumbers(references) {
		if (!references) return [];

		let refArray = [];

		if (typeof references === 'string') {
			refArray = references
				.split(',')
				.map((ref) => ref.trim())
				.filter((ref) => ref);
		} else if (Array.isArray(references)) {
			refArray = references;
		}

		return refArray;
	}

	const refNumbers = parseReferenceNumbers(details.client_reference_numbers);

	let clientRefDisplay;

	if (refNumbers.length === 0) {
		clientRefDisplay = <LRSummaryItemBlock title="Customer Ref. Number" value="-" />;
	} else if (refNumbers.length === 1) {
		clientRefDisplay = (
			<LRSummaryItemBlock title="Customer Ref. Number" value={refNumbers[0]} />
		);
	} else {
		const totalColumns = 4;
		const totalRows = Math.ceil(refNumbers.length / totalColumns);

		const grid = [];
		for (let r = 0; r < totalRows; r += 1) {
			const row = [];
			for (let c = 0; c < totalColumns; c += 1) {
				const index = r * totalColumns + c;
				if (index < refNumbers.length) {
					row.push(refNumbers[index]);
				} else {
					row.push(null);
				}
			}
			grid.push(row);
		}

		clientRefDisplay = (
			<Row style={{ paddingBottom: '20px' }}>
				<Col span={24}>
					<Row>
						<Col>
							<Text style={{ ...LRStyle.locationStyle }}>Customer Ref. Numbers:</Text>
						</Col>
					</Row>
					<Row>
						<Col style={{ marginTop: '10px', width: '100%' }}>
							<table
								style={{
									width: '100%',
									tableLayout: 'fixed',
									borderCollapse: 'collapse',
									border: BORDER_STYLE,
								}}
							>
								<tbody>
									{grid.map((row) => (
										<tr key={generateId()} style={{ height: '26px' }}>
											{row.map((cell) => {
												if (cell) {
													return (
														<td
															key={generateId()}
															style={{ ...tableCellStyle }}
														>
															{cell}
														</td>
													);
												}
												return (
													/* eslint-disable-next-line jsx-a11y/control-has-associated-label */
													<td
														key={generateId()}
														style={{
															padding: '4px 8px',
															border: '0px',
														}}
														aria-label="Empty reference cell"
													/>
												);
											})}
										</tr>
									))}
								</tbody>
							</table>
						</Col>
					</Row>
				</Col>
			</Row>
		);
	}

	return (
		<Row gutter={20} justify="center">
			<Col>
				<QRCode value={JSON.stringify(details)} size={128} />
			</Col>
			<Col span={16}>
				<Row justify="space-between">
					<Col>
						<LRSummaryItemBlock
							title="Gross Weight (Ton)"
							value={details.gross_weight}
						/>
						<LRSummaryItemBlock title="Vehicle Number" value={details.vehicle_number} />
					</Col>
					<Col>
						<LRSummaryItemBlock
							title="Description of Goods"
							value={details.goods_description}
						/>
						<LRSummaryItemBlock title="EWB Number" value={details.ewb_number} />
					</Col>
					<Col>
						<LRSummaryItemBlock
							title="Declared Value"
							value={`Rs.${details.declared_value}`}
						/>
						{clientRefDisplay}
					</Col>
				</Row>
			</Col>
		</Row>
	);
}

LRViewSummary.propTypes = {
	details: PropTypes.object,
};
